import reportWebVitals from './reportWebVitals';
import './modules/account/address';
import './modules/account/payment';
import './modules/account/subscription';
import './modules/account/membership';
import './modules/account/orders';
import './modules/account/dashboard';
import * as serviceWorker from './serviceWorker';

// Module initialisieren sich selbst, keine direkten Imports notwendig.

console.log('[IPS-React] Main index.tsx geladen.');

// (keine globalen Root-Apps mehr – Module initialisieren sich selbst)
serviceWorker.unregister();
reportWebVitals();
